
import { IItemCache } from '../models/IItemCacheObserver';
import { IItemCacheThunkAction, IItemCacheDispatch } from '../store/actions/ItemCacheActions';
import { IItemCacheState } from '../store/reducers/itemCacheReducer';
import { observeItemsUntilResolved } from './observeItems';

/**
 * Creates an action which, when dispatched, produces a set of data
 * extracted from the item cache only once the request is fully resolved.
 * @public
 */
export function demandItems<T>(readDataFromItemCache: (itemCache: IItemCache) => T): IItemCacheThunkAction<Promise<T>> {
  return async (dispatch: IItemCacheDispatch, getState: () => IItemCacheState) => {
    let finalResult: {
      result: T;
    } | undefined;

    let attemptsRemaining = 3;

    for await (const result of dispatch(observeItemsUntilResolved(readDataFromItemCache))) {
      finalResult = {
        result
      };

      attemptsRemaining--;

      if (attemptsRemaining < 0) {
        throw new Error('Unable to resolve items.');
      }
    }

    if (!finalResult) {
      throw new Error('No result.');
    }

    return finalResult.result;
  };
}
